cm.assetsManifests = {

	Boot: [
		
		{ "id": "PreloadSS", "src": "assets/spritesheets/preload.json", "type": "spritesheet"},
		{ "id": "CurtainsAnim", "src": "assets/animations/curtains/curtains.js", "type":"flash_animation" },
		
		{ "id": "oldXMLSoundConfig", "src": "assets/config/soundFiles.xml"},

		{ "id": "EDUT_001", "src": "assets/audio/vo/EDUT_001.mp3"},
		{ "id": "EDUT_003", "src": "assets/audio/vo/EDUT_003.mp3"},
		{ "id": "EDUT_004", "src": "assets/audio/vo/EDUT_004.mp3"},
		{ "id": "DressUpMusic_01Sting", "src": "assets/audio/music/DressUpMusic_01Sting.mp3"}

	],

	Main: [
		{"id": "ChallengeBG", "src": "assets/images/challenge_bg.jpg"},
		{"id": "ChallengeNoLightBG", "src": "assets/images/snapshot_bg.jpg"},
		{"id": "CharacterSelectBG", "src": "assets/images/char_select_bg.jpg"},
		{"id": "MainAnimsLib", "src": "assets/animations/gamelib/gamelib.js", "type":"flash_animation"},
		{"id": "LipsyncSymbolsLib", "src": "assets/animations/lipsync/lipsync.js", "type":"flash_animation"},
	
		{"id": "abby_giggle", "src": "assets/audio/sfx/abby_giggle.mp3"},
		{"id": "CA1", "src": "assets/audio/sfx/CA1.mp3"},
		{"id": "camClick", "src": "assets/audio/sfx/camClick.mp3"},
		{"id": "camera", "src": "assets/audio/sfx/camera.mp3"},
		{"id": "charsel_btn_rollover", "src": "assets/audio/sfx/charsel_btn_rollover.mp3"},
		{"id": "click1", "src": "assets/audio/sfx/click1.mp3"},
		{"id": "click2", "src": "assets/audio/sfx/click2.mp3"},
		{"id": "click3", "src": "assets/audio/sfx/click3.mp3"},
		{"id": "click4", "src": "assets/audio/sfx/click4.mp3"},
		{"id": "click5", "src": "assets/audio/sfx/click5.mp3"},
		{"id": "curtain_O-C", "src": "assets/audio/sfx/curtain_O-C.mp3"},
		{"id": "curtainClose", "src": "assets/audio/sfx/curtainClose.mp3"},
		{"id": "curtainOpen", "src": "assets/audio/sfx/curtainOpen.mp3"},
		{"id": "dance1_1", "src": "assets/audio/sfx/dance1_1.mp3"},
		{"id": "dance1_2", "src": "assets/audio/sfx/dance1_2.mp3"},
		{"id": "dance1_3", "src": "assets/audio/sfx/dance1_3.mp3"},
		{"id": "dance2_1", "src": "assets/audio/sfx/dance2_1.mp3"},
		{"id": "dance2_2", "src": "assets/audio/sfx/dance2_2.mp3"},
		{"id": "dance2_3", "src": "assets/audio/sfx/dance2_3.mp3"},
		{"id": "dance3_1", "src": "assets/audio/sfx/dance3_1.mp3"},
		{"id": "dance3_2", "src": "assets/audio/sfx/dance3_2.mp3"},
		{"id": "dance3_3", "src": "assets/audio/sfx/dance3_3.mp3"},
		{"id": "dance3_4", "src": "assets/audio/sfx/dance3_4.mp3"},
		{"id": "dance3_5", "src": "assets/audio/sfx/dance3_5.mp3"},
		{"id": "dance4_1", "src": "assets/audio/sfx/dance4_1.mp3"},
		{"id": "dance4_2", "src": "assets/audio/sfx/dance4_2.mp3"},
		{"id": "dance5_1", "src": "assets/audio/sfx/dance5_1.mp3"},
		{"id": "dance5_2", "src": "assets/audio/sfx/dance5_2.mp3"},
		{"id": "dance6_1", "src": "assets/audio/sfx/dance6_1.mp3"},
		{"id": "dance6_2", "src": "assets/audio/sfx/dance6_2.mp3"},
		{"id": "elmo_giggle", "src": "assets/audio/sfx/elmo_giggle.mp3"},
		{"id": "ro1", "src": "assets/audio/sfx/ro1.mp3"},
		{"id": "ro3", "src": "assets/audio/sfx/ro3.mp3"},
		{"id": "ro4", "src": "assets/audio/sfx/ro4.mp3"},
		{"id": "ro5", "src": "assets/audio/sfx/ro5.mp3"},
		{"id": "silence", "src": "assets/audio/sfx/silence.mp3"},
		{"id": "WA2", "src": "assets/audio/sfx/WA2.mp3"}
	],

	CharacterSelect: [
		{"id": "EDUT_007", "src": "assets/audio/vo/EDUT_007.mp3"},
		{"id": "EDUT_008", "src": "assets/audio/vo/EDUT_008.mp3"},
		{"id": "EDUT_011", "src": "assets/audio/vo/EDUT_011.mp3"},
		{"id": "EDUT_012", "src": "assets/audio/vo/EDUT_012.mp3"},
		{"id": "EDUT_015", "src": "assets/audio/vo/EDUT_015.mp3"},
		{"id": "EDUT_016", "src": "assets/audio/vo/EDUT_016.mp3"},
		{"id": "DressUpMusic_02introLoop", "src": "assets/audio/music/DressUpMusic_02introLoop.mp3"},
		{"id": "DressUpMusic_07v2", "src": "assets/audio/music/DressUpMusic_07v2.mp3"}
	],

	AllChallenges: [
		{"id": "DressUpMusic_02", "src": "assets/audio/music/DressUpMusic_02.mp3"}
	],

	RegChallengePack: [
		{"id": "ChallengeSetAnimsLib", "src": "assets/animations/regular-challenge-sets/regular-challenge-sets.js", "type":"flash_animation"},
		{"id": "freeplaySnapshotBG", "src": "assets/images/texture_snapshot_freeplayBG.png"}
	],
	
	ColorChallengePack: [
		{"id": "ChallengeSetAnimsLib", "src": "assets/animations/color-challenge-sets/color-challenge-sets.js", "type":"flash_animation"},
		{"id": "freeplaySnapshotBG", "src": "assets/images/texture_snapshot_freeplayBG.png"}
	],

	PatternChallengePack: [
		{"id": "ChallengeSetAnimsLib", "src": "assets/animations/pattern-challenge-sets/pattern-challenge-sets.js", "type":"flash_animation"},
		{"id": "freeplaySnapshotBG", "src": "assets/images/texture_snapshot_freeplayBG.png"}
	],

	DanceOff: [

	],

	ElmoCommonChallengeVO: [
		{"id": "EDUT_021", "note": "elmo_halloween_challengePackIntro", "src": "assets/audio/vo/EDUT_021.mp3"},
		{"id": "EDUT_022", "note": "elmo_holidays_challengePackIntro", "src": "assets/audio/vo/EDUT_022.mp3"},
		{"id": "EDUT_023", "note": "elmo_valentines_challengePackIntro", "src": "assets/audio/vo/EDUT_023.mp3"},
		{"id": "EDUT_024", "note": "elmo_summer_challengePackIntro", "src": "assets/audio/vo/EDUT_024.mp3"},

		{"id": "EDUT_020a", "note": "elmo_roundIntro1" , "src": "assets/audio/vo/EDUT_020a.mp3"},
		{"id": "EDUT_024a", "note": "elmo_roundIntro1Response" , "src": "assets/audio/vo/EDUT_024a.mp3"},
		{"id": "EDUT_028a", "note": "elmo_roundIntro2" , "src": "assets/audio/vo/EDUT_028a.mp3"},
		{"id": "EDUT_025", "note": "elmo_like_request" , "src": "assets/audio/vo/EDUT_025.mp3"},
		{"id": "EDUT_029", "note": "elmo_color_request" , "src": "assets/audio/vo/EDUT_029.mp3"},
		{"id": "EDUT_033", "note": "elmo_free_request" , "src": "assets/audio/vo/EDUT_033.mp3"},
		{"id": "EDUT_026", "note": "elmo_roundIntroRequestFollowup" , "src": "assets/audio/vo/EDUT_026.mp3"},
		{"id": "EDUT_034", "note": "elmo_freeRequestFollowup" , "src": "assets/audio/vo/EDUT_034.mp3"},
	
		{"id": "EDUT_088", "note": "elmo_color_complete" , "src": "assets/audio/vo/EDUT_088.mp3"},
		{"id": "EDUT_089", "note": "elmo_color_completeResponse" , "src": "assets/audio/vo/EDUT_089.mp3"},
		{"id": "EDUT_090", "note": "elmo_pattern_complete" , "src": "assets/audio/vo/EDUT_090.mp3"},
		{"id": "EDUT_091", "note": "elmo_pattern_completeResponse" , "src": "assets/audio/vo/EDUT_091.mp3"},
		{"id": "EDUT_092", "note": "elmo_free_complete" , "src": "assets/audio/vo/EDUT_092.mp3"},
		{"id": "EDUT_093", "note": "elmo_free_completeResponse" , "src": "assets/audio/vo/EDUT_093.mp3"},

		{"id": "EDUT_045", "note": "elmo_wrong1" , "src": "assets/audio/vo/EDUT_045.mp3"},
		{"id": "EDUT_046", "note": "elmo_wrong2_like" , "src": "assets/audio/vo/EDUT_046.mp3"},
		{"id": "EDUT_047", "note": "elmo_wrong2_color" , "src": "assets/audio/vo/EDUT_047.mp3"},
		{"id": "EDUT_048", "note": "elmo_specialhelp_stripes" , "src": "assets/audio/vo/EDUT_048.mp3"},
		{"id": "EDUT_049", "note": "elmo_specialhelp_dots" , "src": "assets/audio/vo/EDUT_049.mp3"},
		{"id": "EDUT_050", "note": "elmo_specialhelp_checkers" , "src": "assets/audio/vo/EDUT_050.mp3"},
		{"id": "EDUT_055", "note": "elmo_wrong3" , "src": "assets/audio/vo/EDUT_055.mp3"},

		{"id": "EDUT_035", "note": "elmo_challengeIdle1" , "src": "assets/audio/vo/EDUT_035.mp3"},
		{"id": "EDUT_038", "note": "elmo_challengeIdle2_like" , "src": "assets/audio/vo/EDUT_038.mp3"},
		{"id": "EDUT_039", "note": "elmo_challengeIdle2_color" , "src": "assets/audio/vo/EDUT_039.mp3"},
		{"id": "EDUT_040", "note": "elmo_challengeIdle2_pattern" , "src": "assets/audio/vo/EDUT_040.mp3"},
		{"id": "EDUT_041", "note": "elmo_challengeIdle2_free" , "src": "assets/audio/vo/EDUT_041.mp3"},
		{"id": "EDUT_042", "note": "elmo_challengeIdle3_topMissing" , "src": "assets/audio/vo/EDUT_042.mp3"},
		{"id": "EDUT_043", "note": "elmo_challengeIdle3_middleMissing" , "src": "assets/audio/vo/EDUT_043.mp3"},
		{"id": "EDUT_044", "note": "elmo_challengeIdle3_bottomMissing", "src": "assets/audio/vo/EDUT_044.mp3"},
	
		{"id": "EDUT_313", "note": "elmo_pattern-checkers_roundIntro", "src": "assets/audio/vo/EDUT_313.mp3"},
		{"id": "EDUT_310", "note": "elmo_pattern-stripes_roundIntro", "src": "assets/audio/vo/EDUT_310.mp3"},
		{"id": "EDUT_311", "note": "elmo_pattern-dots_roundIntro", "src": "assets/audio/vo/EDUT_311.mp3"},
		{"id": "EDUT_314", "note": "elmo_color-green_roundIntro", "src": "assets/audio/vo/EDUT_314.mp3"},
		{"id": "EDUT_315", "note": "elmo_color-blue_roundIntro", "src": "assets/audio/vo/EDUT_315.mp3"},
		{"id": "EDUT_316", "note": "elmo_color-yellow_roundIntro", "src": "assets/audio/vo/EDUT_316.mp3"},
		{"id": "EDUT_317", "note": "elmo_color-orange_roundIntro", "src": "assets/audio/vo/EDUT_317.mp3"},
		{"id": "EDUT_318", "note": "elmo_color-purple_roundIntro", "src": "assets/audio/vo/EDUT_318.mp3"}

	],

	AbbyCommonChallengeVO: [
		{"id": "EDUT_098", "note": "abby_halloween_challengePackIntro", "src": "assets/audio/vo/EDUT_098.mp3"},
		{"id": "EDUT_099", "note": "abby_holidays_challengePackIntro", "src": "assets/audio/vo/EDUT_099.mp3"},
		{"id": "EDUT_100", "note": "abby_valentines_challengePackIntro", "src": "assets/audio/vo/EDUT_100.mp3"},
		{"id": "EDUT_101", "note": "abby_summer_challengePackIntro", "src": "assets/audio/vo/EDUT_101.mp3"},

		{"id": "EDUT_097a", "note": "abby_roundIntro1", "src": "assets/audio/vo/EDUT_097a.mp3"},
		{"id": "EDUT_101a", "note": "abby_roundIntro1Response", "src": "assets/audio/vo/EDUT_101a.mp3"},
		{"id": "EDUT_105a", "note": "abby_roundIntro2", "src": "assets/audio/vo/EDUT_105a.mp3"},
		{"id": "EDUT_102", "note": "abby_like_request", "src": "assets/audio/vo/EDUT_102.mp3"},
		{"id": "EDUT_106", "note": "abby_color_request", "src": "assets/audio/vo/EDUT_106.mp3"},
		{"id": "EDUT_110", "note": "abby_free_request", "src": "assets/audio/vo/EDUT_110.mp3"},
		{"id": "EDUT_103", "note": "abby_roundIntroRequestFollowup", "src": "assets/audio/vo/EDUT_103.mp3"},
		{"id": "EDUT_111", "note": "abby_freeRequestFollowup", "src": "assets/audio/vo/EDUT_111.mp3"},

		{"id": "EDUT_319", "note": "abby_color_complete", "src": "assets/audio/vo/EDUT_319.mp3"},
		{"id": "EDUT_320", "note": "abby_color_completeResponse", "src": "assets/audio/vo/EDUT_320.mp3"},
		{"id": "EDUT_321", "note": "abby_pattern_complete", "src": "assets/audio/vo/EDUT_321.mp3"},
		{"id": "EDUT_322", "note": "abby_pattern_completeResponse", "src": "assets/audio/vo/EDUT_322.mp3"},
		{"id": "EDUT_323", "note": "abby_free_complete", "src": "assets/audio/vo/EDUT_323.mp3"},
		{"id": "EDUT_324", "note": "abby_free_completeResponse", "src": "assets/audio/vo/EDUT_324.mp3"},
	
		{"id": "EDUT_122", "note": "abby_wrong1", "src": "assets/audio/vo/EDUT_122.mp3"},
		{"id": "EDUT_124", "note": "abby_wrong2_like", "src": "assets/audio/vo/EDUT_124.mp3"},
		{"id": "EDUT_125", "note": "abby_wrong2_color", "src": "assets/audio/vo/EDUT_125.mp3"},
		{"id": "EDUT_126", "note": "abby_specialhelp_stripes", "src": "assets/audio/vo/EDUT_126.mp3"},
		{"id": "EDUT_127", "note": "abby_specialhelp_dots", "src": "assets/audio/vo/EDUT_127.mp3"},
		{"id": "EDUT_128", "note": "abby_specialhelp_checkers", "src": "assets/audio/vo/EDUT_128.mp3"},
		{"id": "EDUT_134", "note": "abby_wrong3", "src": "assets/audio/vo/EDUT_134.mp3"},

		{"id": "EDUT_112", "note": "abby_challengeIdle1", "src": "assets/audio/vo/EDUT_112.mp3"},
		{"id": "EDUT_115", "note": "abby_challengeIdle2_like", "src": "assets/audio/vo/EDUT_115.mp3"},
		{"id": "EDUT_116", "note": "abby_challengeIdle2_color", "src": "assets/audio/vo/EDUT_116.mp3"},
		{"id": "EDUT_117", "note": "abby_challengeIdle2_pattern", "src": "assets/audio/vo/EDUT_117.mp3"},
		{"id": "EDUT_118", "note": "abby_challengeIdle2_free", "src": "assets/audio/vo/EDUT_118.mp3"},
		{"id": "EDUT_119", "note": "abby_challengeIdle3_topMissing", "src": "assets/audio/vo/EDUT_119.mp3"},
		{"id": "EDUT_120", "note": "abby_challengeIdle3_middleMissing", "src": "assets/audio/vo/EDUT_120.mp3"},
		{"id": "EDUT_121", "note": "abby_challengeIdle3_bottomMissing", "src": "assets/audio/vo/EDUT_121.mp3"},

		{"id": "EDUT_273", "note": "abby_pattern-checkers_roundIntro", "src": "assets/audio/vo/EDUT_273.mp3"},
		{"id": "EDUT_270", "note": "abby_pattern-stripes_roundIntro", "src": "assets/audio/vo/EDUT_270.mp3"},
		{"id": "EDUT_271", "note": "abby_pattern-dots_roundIntro", "src": "assets/audio/vo/EDUT_271.mp3"},
		{"id": "EDUT_274", "note": "abby_color-green_roundIntro", "src": "assets/audio/vo/EDUT_274.mp3"},
		{"id": "EDUT_275", "note": "abby_color-blue_roundIntro", "src": "assets/audio/vo/EDUT_275.mp3"},
		{"id": "EDUT_276", "note": "abby_color-yellow_roundIntro", "src": "assets/audio/vo/EDUT_276.mp3"},
		{"id": "EDUT_277", "note": "abby_color-orange_roundIntro", "src": "assets/audio/vo/EDUT_277.mp3"},
		{"id": "EDUT_278", "note": "abby_color-purple_roundIntro", "src": "assets/audio/vo/EDUT_278.mp3"}
	],

	ElmoDanceoffVO: [
		{"id": "EDUT_180", "note": "elmo_dance_danceIntro" , "src": "assets/audio/vo/EDUT_180.mp3"},
		{"id": "EDUT_181", "note": "elmo_dance_danceIdle1" , "src": "assets/audio/vo/EDUT_181.mp3"},
		{"id": "EDUT_182", "note": "elmo_dance_danceIdle2" , "src": "assets/audio/vo/EDUT_182.mp3"},
		{"id": "EDUT_187", "note": "elmo_dance_danceIdle3" , "src": "assets/audio/vo/EDUT_187.mp3"},
		{"id": "EDUT_201", "note": "elmo_dance_dance1" , "src": "assets/audio/vo/EDUT_201.mp3"},
		{"id": "EDUT_202", "note": "elmo_dance_dance2" , "src": "assets/audio/vo/EDUT_202.mp3"},
		{"id": "EDUT_197", "note": "elmo_dance_dance3" , "src": "assets/audio/vo/EDUT_197.mp3"},
		{"id": "EDUT_199", "note": "elmo_dance_dance4" , "src": "assets/audio/vo/EDUT_199.mp3"},
		{"id": "EDUT_198", "note": "elmo_dance_dance5" , "src": "assets/audio/vo/EDUT_198.mp3"},
		{"id": "EDUT_200", "note": "elmo_dance_dance6" , "src": "assets/audio/vo/EDUT_200.mp3"},
		{"id": "EDUT_237", "note": "elmo_dance_changeOutfit", "src": "assets/audio/vo/EDUT_237.mp3"},
		{"id": "EDUT_238", "note": "elmo_dance_startOver", "src": "assets/audio/vo/EDUT_238.mp3"},
		{"id": "EDUT_234", "note": "elmo_dance_pressThis", "src": "assets/audio/vo/EDUT_234.mp3"},
	],

	AbbyDanceoffVO: [
		{"id": "EDUT_204", "note": "abby_dance_danceIntro" , "src": "assets/audio/vo/EDUT_204.mp3"},
		{"id": "EDUT_205", "note": "abby_dance_danceIdle1" , "src": "assets/audio/vo/EDUT_205.mp3"},
		{"id": "EDUT_206", "note": "abby_dance_danceIdle2" , "src": "assets/audio/vo/EDUT_206.mp3"},
		{"id": "EDUT_211", "note": "abby_dance_danceIdle3" , "src": "assets/audio/vo/EDUT_211.mp3"},
		{"id": "EDUT_220", "note": "abby_dance_dance1" , "src": "assets/audio/vo/EDUT_220.mp3"},
		{"id": "EDUT_223", "note": "abby_dance_dance2" , "src": "assets/audio/vo/EDUT_223.mp3"},
		{"id": "EDUT_221", "note": "abby_dance_dance3" , "src": "assets/audio/vo/EDUT_221.mp3"},
		{"id": "EDUT_218", "note": "abby_dance_dance4" , "src": "assets/audio/vo/EDUT_218.mp3"},
		{"id": "EDUT_224", "note": "abby_dance_dance6" , "src": "assets/audio/vo/EDUT_224.mp3"},
		{"id": "EDUT_230", "note": "abby_dance_changeOutfit", "src": "assets/audio/vo/EDUT_230.mp3"},
		{"id": "EDUT_231", "note": "abby_dance_startOver", "src": "assets/audio/vo/EDUT_231.mp3"},
		{"id": "EDUT_227", "note": "abby_dance_pressThis", "src": "assets/audio/vo/EDUT_227.mp3"}
	]


};